import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { Form, Formik } from 'formik';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import SnackAlert from '../../../Components/AlertComponents/Snack/SnackAlert';
import {
  FooterButtons,
  FullHeightBox,
  StyledStepper,
} from './OrdemServicoCadastrarStyle';
import ModalItem from '../Modais/ModalItem';
import { Alert } from '@mui/material';
import ModalPeca from '../Modais/ModalPeca';
import ModalServico from '../Modais/ModalServico';
import Snackbar from '@mui/material/Snackbar';
import OrdemServicoCadastro from './OrdemServicoCadastro';
import OrdemServicoItens from './OrdemServicoItens';
import OrdemServicoPecas from './OrdemServicoPecas';
import OrdemServicoServicos from './OrdemServicoServicos';
import OrdemServicoFinalizar from './OrdemServicoFinalizar';
import { Loader } from '../../../../shared/components/Loader';
import { useOrderServicoCadastrar } from '../../../../hooks/useOrderServicoCadastrar';
import { useParams, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

let duploClickLocation = false

export default function OrdemServicoCadastrar() {
  const { id } = useParams();
  const location = useLocation()
  const isCloning = location.pathname.includes('clonar')

  useEffect(() => {
    duploClickLocation = location.state?.duploClick || false;
  }, [])

  const OrdemServicoId = id ? parseInt(id, 10) : null;
  const {
    duploClick,
    steps,
    activeStep,
    snack,
    modalItensOpen,
    modalPecasOpen,
    modalServicosOpen,
    usuarios,
    setUsuarioSelecionado,
    clientes,
    setClienteSelecionado,
    snackOpen,
    loading,
    isTryingToAdvance,
    initialValues,
    validationSchema,
    handleNext,
    handleBack,
    handleCloseSnack,
    handleOpenItensModal,
    handleCloseItensModal,
    handleOpenPecasModal,
    handleClosePecasModal,
    handleOpenServicosModal,
    handleCloseServicosModal,
    handleSubmit,
    CloseModal,
    // Status A Faturar / Reprovado / Finalizado: so Data de Entrega e Descricao
    // ficam liberadas; nos demais status a OS e editavel por inteiro.
    edicaoRestrita,
    podeEditarGerarPedido,
  } = useOrderServicoCadastrar(OrdemServicoId, isCloning, duploClickLocation);

  return (
    <Loader loading={loading}>
      <FullHeightBox>
        <HeaderComponent text={'CADASTRO DE ORDEM DE SERVIÇOS'} className={'mb-5'} />

        {
          snack !== null && <SnackAlert
            modalProps={{
              title: snack.title ?? '',
              description: snack.description ?? '',
              colorType: snack.colorType ?? '',
            }}
            onClose={CloseModal}
          />
        }

        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnMount
        >
          {({ values, errors, setErrors, validateForm, touched, setFieldValue, setSubmitting, resetForm }) => {

            return (
              <>
                <StyledStepper activeStep={activeStep} alternativeLabel className={'cursor-pointer'}>
                  {steps.map((label, index) => (
                    <Step
                      key={label}
                      onClick={() => handleNext(validateForm, setErrors, index)}
                      className={'cursor-pointer'}
                    >
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </StyledStepper>
                <Form>
                  {activeStep === 0 && (
                    <OrdemServicoCadastro
                      errors={errors}
                      touched={touched}
                      isTryingToAdvance={isTryingToAdvance}
                      edicaoRestrita={edicaoRestrita}
                      usuarios={usuarios}
                      clientes={clientes}
                      setUsuarioSelecionado={setUsuarioSelecionado}
                      setClienteSelecionado={setClienteSelecionado}
                      duploClick={duploClick}
                    />
                  )}

                  {activeStep === 1 && (
                    <OrdemServicoItens
                      edicaoRestrita={edicaoRestrita}
                      values={values}
                      handleOpenItensModal={handleOpenItensModal}
                      setFieldValue={setFieldValue}
                      duploClick={duploClick}
                    />
                  )}

                  {activeStep === 2 && (
                    <OrdemServicoPecas
                      edicaoRestrita={edicaoRestrita}
                      values={values}
                      handleOpenPecasModal={handleOpenPecasModal}
                      setFieldValue={setFieldValue}
                      duploClick={duploClick}
                    />
                  )}

                  {activeStep === 3 && (
                    <OrdemServicoServicos
                      edicaoRestrita={edicaoRestrita}
                      values={values}
                      handleOpenPecasModal={handleOpenServicosModal}
                      setFieldValue={setFieldValue}
                      duploClick={duploClick}
                    />
                  )}

                  {activeStep === 4 && (
                    <OrdemServicoFinalizar
                      values={values}
                      duploClick={duploClick}
                      podeEditarGerarPedido={podeEditarGerarPedido}
                      setFieldValue={setFieldValue}
                    />
                  )}
                  <FooterButtons>
                    <Button
                      onClick={handleBack}
                      variant='contained'
                      color='warning'
                    >
                      Voltar
                    </Button>

                    {/* No modo restrito o Salvar fica disponivel ja no primeiro passo:
                        as unicas alteracoes possiveis sao a data de entrega e a descricao. */}
                    {activeStep < steps.length - 1 && !edicaoRestrita ? (
                      <Button
                        onClick={() => handleNext(validateForm, setErrors)}
                        variant='contained'
                        color='primary'
                      >
                        Próximo
                      </Button>

                    ) : (
                      <Button
                        type='button'
                        onClick={() => handleSubmit(values, { setSubmitting, resetForm })}
                        variant='contained'
                        color='success'
                        disabled={duploClick}
                      >
                        Salvar
                      </Button>
                    )}
                  </FooterButtons>
                  <ModalItem
                    open={modalItensOpen}
                    onClose={handleCloseItensModal}
                    setFieldValue={setFieldValue}
                    values={values}
                  />
                  <ModalPeca
                    open={modalPecasOpen}
                    onClose={handleClosePecasModal}
                    setFieldValue={setFieldValue}
                    values={values}
                  />
                  <ModalServico
                    open={modalServicosOpen}
                    onClose={handleCloseServicosModal}
                    setFieldValue={setFieldValue}
                    values={values}
                  />
                </Form>
              </>
            )
          }}
        </Formik>

        <Snackbar
          open={snackOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="error"
            sx={{
              backgroundColor: '#C62828',
              width: '100%',
              color: '#fff',
              fontSize: '16px',
            }}
          >
            Você precisa adicionar pelo menos um item!
          </Alert>
        </Snackbar>
      </FullHeightBox>
    </Loader>
  );
}
